import { BENEFITS } from "../config/brand";
import { FadeUp, LineReveal } from "../components/Reveal";

export const Benefits = () => (
  <section className="bg-ivory" aria-label="Benefits" data-testid="benefits-section">
    <div className="mx-auto max-w-[1280px] px-5 py-20 sm:px-8 lg:py-28">
      <LineReveal
        as="h2"
        lines={["What changes when your life", "and your goals finally have a system?"]}
        className="max-w-4xl font-serif text-4xl font-medium leading-[1.1] tracking-tight text-plum sm:text-5xl"
      />
      <div className="mt-14 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((b, i) => (
          <FadeUp key={b.number} delay={i * 0.06}>
            <div data-testid={`benefit-${b.number}`} className="group relative pt-6">
              <span className="absolute left-0 top-0 h-[2px] w-10 rounded-full bg-plum/25 transition-[width,background-color] duration-400 group-hover:w-full group-hover:bg-rose" />
              <p className="font-serif text-lg italic text-rose transition-transform duration-300 group-hover:-translate-y-0.5">
                {b.number}
              </p>
              <h3 className="mt-2 font-serif text-2xl font-semibold tracking-tight text-plum transition-transform duration-300 group-hover:translate-x-1">
                {b.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-plumcharcoal/70">{b.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
